import React from 'react';
import BarLine from '../common/graphs/barLineNew';

const BarBPM = props => (
  <div className={`main_summary_graph__color ${props.width}`}>
    <a className="normal" data-tags={false}>
      {props.distribution && (
        <BarLine
          name="state"
          value="value"
          distribution={props.distribution}
          language={props.title.summary.graphTooltip}
        />
      )}
    </a>
    {props.text && <h3>{props.language.summary.nfa.distributionRisk}</h3>}
  </div>
);

export default BarBPM;



// WEBPACK FOOTER //
// ./source/client/components/summary_ffd_pvt/barBPM.jsx